import { ApiService } from '@base/services/base.api.service';
import { BaseComponent } from '@base/component/base.component';
import { ServiceLocator } from '@base/constants/service-locator';
import { Observable } from 'rxjs';
import { METHOD_REFERENCE, API_REFERENCE, API_PATH } from '@base/constants/base.constants';
import { Injectable } from '@angular/core';

@Injectable()
export class SearchService {
    public apiService: ApiService;
    public baseComponent: BaseComponent;

    constructor() {
        this.apiService = ServiceLocator.injector.get(ApiService);
        this.baseComponent = ServiceLocator.injector.get(BaseComponent);
    }

    public getSearchResult(searchObject): Observable<any> {
        const options = this.baseComponent.getRequestOptions(
            METHOD_REFERENCE['GET'], API_REFERENCE['search']['search'] + searchObject,
            {}, null, null, null, false, true, API_PATH);
        return this.apiService.apiCall(options);
    }
}